var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserWithoutBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13655_168288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4151 12C13.7024 12 16.3666 9.31359 16.3666 6C16.3666 2.68641 13.7024 0 10.4151 0C7.12783 0 4.46361 2.68641 4.46361 6C4.46361 9.31359 7.12783 12 10.4151 12ZM12.7724 14.25H8.05775C3.60855 14.25 0 17.8875 0 22.3734C0 23.2706 0.721617 23.9986 1.61155 23.9986H19.2196C20.1095 24 20.8302 23.2734 20.8302 22.3734C20.8302 17.8875 17.2221 14.25 12.7724 14.25Z",
    fill: "#848484"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13655_168288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8302,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWithoutBg);
export default __webpack_public_path__ + "static/media/user-without-bg.a448fc78f50db23a1cf1ff3cfe9f7ba7.svg";
export { ForwardRef as ReactComponent };